import {
    NumberedBreadcrumbs,
    type Breadcrumb,
} from 'shells/numbered-breadcrumbs/numbered-breadcrumbs';

import type {EmailSetupStep} from './types';

interface Props {
    currentStep: EmailSetupStep;
    setCurrentStep: (step: EmailSetupStep) => void;
}

export function EmailSettingsSetupBreadcrumbs(props: Props) {
    const breadcrumbs: Breadcrumb[] = [
        {
            id: 'add-email',
            title: 'Add email address',
            selectable: true,
        },
        {
            id: 'name-inbox',
            title: 'Name your inbox',
            selectable: props.currentStep === 'name-inbox',
        },
    ];

    return (
        <NumberedBreadcrumbs
            breadcrumbs={breadcrumbs}
            selectedValue={props.currentStep}
            onSelectValue={(step: string) => props.setCurrentStep(step as EmailSetupStep)}
            onlyDisplaySubtitleWhenCompleted={true}
            subtitleSize='mini'
            subtitleColor='light'
        />
    );
}
